import { render, staticRenderFns } from "./seoPageTab.vue?vue&type=template&id=5a2fd93d&scoped=true&lang=pug"
import script from "./seoPageTab.vue?vue&type=script&lang=js"
export * from "./seoPageTab.vue?vue&type=script&lang=js"
import style0 from "./seoPageTab.vue?vue&type=style&index=0&id=5a2fd93d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2fd93d",
  null
  
)

export default component.exports